import { forwardRef, type HTMLAttributes } from 'react';
import VipIcon from '@assets/img/icons/vip-v2.svg?react';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

interface VipTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const VipTile = forwardRef<HTMLDivElement, VipTileProps>((props, ref) => {
  return (
    <Tile
      ref={ref}
      {...props}
      variant={props.isActive ? 'dark' : 'grey'}
      className={cn(
        props.className,
        'flex flex-col items-center pb-1 pt-[0.4375rem]',
      )}
    >
      <VipIcon className="w-[1.375rem] h-[1.8125rem] relative z-[2]" />
      <StringXSmall
        weight="bold"
        className="!text-[12px] relative z-[2]"
      >{`${30} min`}</StringXSmall>
      {props.isActive && <TilesBg variant="green-active" />}
    </Tile>
  );
});

export { VipTile };
